<div class="filter-wrapper">
  <input type="text" min="0" [(ngModel)]="currentValue" (click)="onClick()" (input)="onInputBoxChanged()"
    (blur)="onBlur()" class="filter-input" />
  <i *ngIf="showClearText" (click)="searchText()" class="sch-thin-x"></i>
  <sdps-icon color="secondary" type="functional" name="search" size="small"></sdps-icon>
</div>